module.exports = __webpack_public_path__ + "static/img/02.dce3a62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotkeSlider/02.jpg
// module id = CVJW
// module chunks = 0